import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DeviceService } from 'src/app/services/device.service';
import { UserService } from 'src/app/services/user.service';
import { format, addDays, parse } from 'date-fns';
import { Error429Service } from 'src/app/services/error429.service';
import { UserDataService } from 'src/app/services/user-data.service';
import { CircularFluidMeter, CircularFluidMeterConfig, Speed } from 'fluid-meter';
@Component({
  selector: 'app-mega',
  templateUrl: './mega.component.html',
  styleUrls: ['./mega.component.css']
})
export class MegaComponent implements OnInit, OnDestroy{

  errorMessage : string =""; //Mensaje de error
  establishmentData: any = []; //Información de los establecimientos
  museoMega: any = []; //Dispositivos de MEGA
  userId: any;
  tiempoEsperaRecarga: number = 60000;
  time = new Date();
  intervalId: any;
  intervaCalcularDatosMega: any;
  firstErrorTimestamp: number | null = null; //Primer error 429

  currentDate = new Date();
  day = this.currentDate.getDate().toString().padStart(2, '0');
  month = (this.currentDate.getMonth() + 1).toString().padStart(2, '0');
  year = this.currentDate.getFullYear();
  formattedDate = `${this.day}/${this.month}/${this.year}`;
  diaActualformateada= `${this.year}-${this.month}-${this.day}`
  fechaActual = new Date (this.diaActualformateada);
  mostrar: boolean | undefined;
  userData: any = [];
  dev_referenceD1: string = "";
  dev_referenceD2: string = "";
  dev_referenceD3: string = "";
  fluidMeters: CircularFluidMeter[] = [];

  //Datos de los tanques
    //Capacidad
      capacidadT1: string = "";
      capacidadT2: string = "";
      capacidadT3: string = "";
      capacidadT4: string = "";
      capacidadT5: string = "";
      capacidadT6: string = "";
      capacidadT7: string = "";
      capacidadT8: string = "";
    //Tipo de cerveza
      tipoCervezaT1: string = "";
      tipoCervezaT2: string = "";
      tipoCervezaT3: string = "";
      tipoCervezaT4: string = "";
      tipoCervezaT5: string = "";
      tipoCervezaT6: string = "";
      tipoCervezaT7: string = "";
      tipoCervezaT8: string = "";
    //Temperatura
      temperaturaT1: string = "";
      temperaturaT2: string = "";
      temperaturaT3: string = "";
      temperaturaT4: string = "";
      temperaturaT5: string = "";
      temperaturaT6: string = "";
      temperaturaT7: string = "";
      temperaturaT8: string = "";
    //Presion
      presionT1: string = "";
      presionT2: string = "";
      presionT3: string = "";
      presionT4: string = "";
      presionT5: string = "";
      presionT6: string = "";
      presionT7: string = "";
      presionT8: string = "";
    //Nivel
      nvlT1: number = 0;
      nvlT2: number = 0;
      nvlT3: number = 0;
      nvlT4: number = 0;
      nvlT5: number = 0;
      nvlT6: number = 0;
      nvlT7: number = 0;
      nvlT8: number = 0;
    //Nivel %
      nivelT1: number = 0;
      nivelT2: number = 0;
      nivelT3: number = 0;
      nivelT4: number = 0;
      nivelT5: number = 0;
      nivelT6: number = 0;
      nivelT7: number = 0;
      nivelT8: number = 0;
    //Ultima fecha de lectura
      fechaUltimaLecturaD1: string = "";
      fechaUltimaLecturaD2: string = "";
      fechaUltimaLecturaD3: string = "";
    //Litro diarios
      consumoLitrosEstrella: number = 0.0;
      consumoLitros1906: number = 0.0;
      consumoLitrosEstrellaCopia: number = 0.0;
      consumoLitros1906Copia: number = 0.0;
    //Caudal
      caudalT1D1: number = 0;
      caudalT2D1: number = 0;
      caudalT3D1: number = 0;
      caudalT1D2: number = 0;
      caudalT2D2: number = 0;
      caudalT1D3: number = 0;
      caudalT2D3: number = 0;
      caudalT3D3: number = 0;
    //Tanque Activo
      condicionT1Activo: boolean = false;
      condicionT2Activo: boolean = false;
      condicionT3Activo: boolean = false;
      condicionT4Activo: boolean = false;
      condicionT5Activo: boolean = false;
      condicionT6Activo: boolean = false;
      condicionT7Activo: boolean = false;
      condicionT8Activo: boolean = false;
    //Fluid-Meter
      FluidMeterT1: CircularFluidMeter | undefined;
      FluidMeterT2: CircularFluidMeter | undefined;
      FluidMeterT3: CircularFluidMeter | undefined;
      FluidMeterT4: CircularFluidMeter | undefined;
      FluidMeterT5: CircularFluidMeter | undefined;
      FluidMeterT6: CircularFluidMeter | undefined;
      FluidMeterT7: CircularFluidMeter | undefined;
      FluidMeterT8: CircularFluidMeter | undefined;
      FluidMeterT9: CircularFluidMeter | undefined;

  /*-------------------------------FechaActualConGuiones------------------------------------------*/
  fechaActualD = new Date();
  mes1 = this.fechaActualD.getMonth() + 1; // Los meses comienzan desde 0, por lo que se suma 1
  fechaFormateada = `${this.fechaActualD.getFullYear()}-${this.mes1.toString().padStart(2, '0')}-${this.fechaActualD.getDate().toString().padStart(2, '0')}`;

  //Historicos
  historicosRaw: any = [];

  private establishmentSubscription: Subscription | undefined;
  private historicoDiaSubscription1: Subscription | undefined;
  private historicoDiaSubscription: Subscription | undefined;

  constructor(private userService: UserService, private router: Router, private deviceService: DeviceService,
    private error429: Error429Service, private userDataService: UserDataService){}
  
  ngOnInit(): void {
    this.userData = this.userDataService.getUserData();
    if (this.userData.cliente_id === 3 || this.userData.pro_id === 4) {
      this.mostrar = true;
      this.establishmentSubscription = this.deviceService.getDevicesDataNew().subscribe({
        next:resp =>{
          this.establishmentData = resp;
          for(let i=0; i<this.establishmentData.length; i++){
            if (this.establishmentData[i].dev_est_id == 12){
              this.museoMega.push(this.establishmentData[i]);
            }
          }
        },error:err =>{
          if (err.status == 429) {
            this.errorMessage = "Se han recibido demasiadas peticiones, espere un minuto por favor, y la página se recargará automáticamente.";
            const storedTimestamp = localStorage.getItem('firstErrorTimestamp');
            if(storedTimestamp == null){
              this.firstErrorTimestamp = new Date().getTime(); // Guardar el timestamp del primer error
              localStorage.setItem('firstErrorTimestamp', this.firstErrorTimestamp.toString());
            } else {
              this.firstErrorTimestamp = storedTimestamp !== null ? parseInt(storedTimestamp, 10) : null;
            }
            this.recargarPaginaDespuesDeTiempo();
          } else {
            this.errorMessage = err.error.message;
          }
        }, complete:() =>{
          /*const fecha1String = "2023-08-03";
          const fecha1 = new Date(fecha1String);*/
          //Conseguimos los datos historicos de mega del día de hoy y calculamos el consumo sumandos los caudales
          const referenciasConGuiones = this.museoMega.map((elemento: any) => `-${elemento.dev_reference}-`);
          this.historicoDiaSubscription1 = this.deviceService.getMultiHistoricRaw(referenciasConGuiones,this.fechaFormateada, this.obtenerDiaSiguiente(this.fechaFormateada),"0").subscribe({
            next: resp => {
              for(let i=0; i<resp.length; i++){
                let consumo = 0;
                for (let j = 0; j < resp[i].readers_raw.length; j++) {
                  consumo +=
                    (resp[i].readers_raw[j].field11 ?? 0) +
                    (resp[i].readers_raw[j].field12 ?? 0) +
                    (resp[i].readers_raw[j].field13 ?? 0) +
                    (resp[i].readers_raw[j].field14 ?? 0) +
                    (resp[i].readers_raw[j].field15 ?? 0) +
                    (resp[i].readers_raw[j].field16 ?? 0) +
                    (resp[i].readers_raw[j].field20 ?? 0) +
                    (resp[i].readers_raw[j].field21 ?? 0) +
                    (resp[i].readers_raw[j].field22 ?? 0);
                }
                this.historicosRaw.push({
                  nombre: resp[i].dev_label,
                  tipoCerveza: resp[i].readers_raw[0].beer_type_id_1,
                  consumoTotal: parseFloat(consumo.toFixed(2)),
                });
              }
            }, error: err => {
              if (err.status == 429) {
                this.errorMessage = "Se han recibido demasiadas peticiones, espere un minuto por favor, y la página se recargará automáticamente.";
                const storedTimestamp = localStorage.getItem('firstErrorTimestamp');
                if(storedTimestamp == null){
                  this.firstErrorTimestamp = new Date().getTime(); // Guardar el timestamp del primer error
                  localStorage.setItem('firstErrorTimestamp', this.firstErrorTimestamp.toString());
                } else {
                  this.firstErrorTimestamp = storedTimestamp !== null ? parseInt(storedTimestamp, 10) : null;
                }
                this.recargarPaginaDespuesDeTiempo();
              } else {
                this.errorMessage = err.error.message;
              }
            }, complete: () => {
              const mega123 = this.historicosRaw.find((historico:any) => historico.nombre == "MEGA: 1-2-3");
              const mega45 = this.historicosRaw.find((historico:any) => historico.nombre == "MEGA: 4-5");
              const mega678 = this.historicosRaw.find((historico:any) => historico.nombre == "MEGA: 6-7-8");
              console.log(mega123);
              console.log(mega45);
              console.log(mega678);

              //Guardamos los datos de los dispositivos de museo mega
              for(let i=0; i<this.museoMega.length; i++){
                if(this.museoMega[i].dev_label == "MEGA: 1-2-3"){
                  let options = JSON.parse(this.museoMega[i].options[0].dev_option_value);
                  this.dev_referenceD1 = this.museoMega[i].dev_reference;
                  this.capacidadT1 = options.cap1;
                  this.capacidadT2 = options.cap2;
                  this.capacidadT3 = options.cap3;
                  this.tipoCervezaT1 = options.beertype1;
                  this.tipoCervezaT2 = options.beertype2;
                  this.tipoCervezaT3 = options.beertype3;
                  this.temperaturaT1 = this.museoMega[i].lastreader.field6;
                  this.temperaturaT2 = this.museoMega[i].lastreader.field7;
                  this.temperaturaT3 = this.museoMega[i].lastreader.field8;
                  this.presionT1 = this.museoMega[i].lastreader.field3;
                  this.presionT2 = this.museoMega[i].lastreader.field4;
                  this.presionT3 = this.museoMega[i].lastreader.field5;
                  if(this.museoMega[i].lastreader.field2=="1"){
                    this.condicionT1Activo = true;
                  } else{ 
                    if(this.museoMega[i].lastreader.field2=="2"){
                      this.condicionT2Activo = true;
                    } else {
                      if(this.museoMega[i].lastreader.field2=="3"){
                        this.condicionT3Activo = true;
                      }
                    }
                  }
                  this.nvlT1 = this.museoMega[i].lastreader.field17;
                  if(this.nvlT1<0){
                    this.nvlT1 = 0;
                  }
                  this.nvlT2 = this.museoMega[i].lastreader.field18;
                  if(this.nvlT2<0){
                    this.nvlT2 = 0;
                  }
                  this.nvlT3 = this.museoMega[i].lastreader.field19;
                  if(this.nvlT3<0){
                    this.nvlT3 = 0;
                  }
                  this.nivelT1 = ((parseFloat(this.museoMega[i].lastreader.field17)*100) / parseInt(options.cap1));
                  this.nivelT2 = ((parseFloat(this.museoMega[i].lastreader.field18)*100) / parseInt(options.cap2));
                  this.nivelT3 = ((parseFloat(this.museoMega[i].lastreader.field19)*100) / parseInt(options.cap3));
                  if(mega123.tipoCerveza == 1){
                    this.consumoLitrosEstrella += mega123.consumoTotal;
                  }
                  if(mega123.tipoCerveza == 2){
                    this.consumoLitros1906 += mega123.consumoTotal;
                  }
                  /*if(this.museoMega[i].lastreader.created_at){
                    this.fechaUltimaLecturaD1 = this.museoMega[i].lastreader.created_at.substring(0,10);
                    const fechaULecturaD1 = new Date(this.fechaUltimaLecturaD1);
                    Comprobar si el día de la última lectura es igual al de la fecha actual para calcular los consumos diarios
                    if(this.sonFechasIguales(fechaULecturaD1,this.fechaActual)){
                      let diaSiguiente = this.obtenerDiaSiguiente(this.fechaUltimaLecturaD1);
                      if(this.tipoCervezaT1=="1" && this.tipoCervezaT2=="1" && this.tipoCervezaT3=="1"){
                        this.historicoDiaSubscription = this.deviceService.getDeviceHisroticDateTimescale
                        (this.dev_referenceD1,this.fechaUltimaLecturaD1, diaSiguiente,"0").subscribe({
                          next: resp =>{
                            for(let reader of resp){
                              this.caudalT1D1 += parseFloat(reader.field11);
                              this.caudalT2D1 += parseFloat(reader.field13);
                              this.caudalT3D1 += parseFloat(reader.field15);
                            }
                            this.consumoLitrosEstrella += this.caudalT1D1 + this.caudalT2D1 + this.caudalT3D1;
                            this.consumoLitrosEstrella = parseFloat(this.consumoLitrosEstrella.toFixed(2));
                          }
                        });
                        //this.consumoLitrosEstrella+=(parseFloat(this.museoMega[i].lastreader.field11) + parseFloat(this.museoMega[i].lastreader.field13) 
                        //  + parseFloat(this.museoMega[i].lastreader.field15));
                      }
                      if(this.tipoCervezaT1=="2" && this.tipoCervezaT2=="2" && this.tipoCervezaT3=="2"){
                        this.historicoDiaSubscription = this.deviceService.getDeviceHisroticDateTimescale
                        (this.dev_referenceD1,this.fechaUltimaLecturaD1, diaSiguiente,"0").subscribe({
                          next: resp =>{
                            for(let reader of resp){
                              this.caudalT1D1 += parseFloat(reader.field11);
                              this.caudalT2D1 += parseFloat(reader.field13);
                              this.caudalT3D1 += parseFloat(reader.field15);
                            }
                            this.consumoLitros1906 += this.caudalT1D1 + this.caudalT2D1 + this.caudalT3D1;
                            this.consumoLitros1906 = parseFloat(this.consumoLitros1906.toFixed(2));
                          }
                        });
                        //this.consumoLitros1906+=(parseFloat(this.museoMega[i].lastreader.field11) + parseFloat(this.museoMega[i].lastreader.field13) 
                        //+ parseFloat(this.museoMega[i].lastreader.field15));
                      }
                    }
                  }*/
                }
                if(this.museoMega[i].dev_label == "MEGA: 4-5"){
                  let options = JSON.parse(this.museoMega[i].options[0].dev_option_value);
                  this.dev_referenceD2 = this.museoMega[i].dev_reference;
                  this.capacidadT4 = options.cap1;
                  this.capacidadT5 = options.cap2;
                  this.tipoCervezaT4 = options.beertype1;
                  this.tipoCervezaT5 = options.beertype2;
                  this.temperaturaT4 = this.museoMega[i].lastreader.field6;
                  this.temperaturaT5 = this.museoMega[i].lastreader.field7;
                  this.presionT4 = this.museoMega[i].lastreader.field3;
                  this.presionT5 = this.museoMega[i].lastreader.field4;
                  if(this.museoMega[i].lastreader.field2=="1"){
                    this.condicionT4Activo = true;
                  } else{ 
                    if(this.museoMega[i].lastreader.field2=="2"){
                      this.condicionT5Activo = true;
                    }
                  }
                  this.nvlT4 = this.museoMega[i].lastreader.field17;
                  if(this.nvlT4<0){
                    this.nvlT4 = 0;
                  }
                  this.nvlT5 = this.museoMega[i].lastreader.field18;
                  if(this.nvlT5<0){
                    this.nvlT5 = 0;
                  }
                  this.nivelT4 = ((parseFloat(this.museoMega[i].lastreader.field17)*100) / parseInt(options.cap1));
                  this.nivelT5 = ((parseFloat(this.museoMega[i].lastreader.field18)*100) / parseInt(options.cap2));
                  if(mega45.tipoCerveza == 1){
                    this.consumoLitrosEstrella += mega45.consumoTotal;
                  }
                  if(mega45.tipoCerveza == 2){
                    this.consumoLitros1906 += mega45.consumoTotal;
                  }
                }
                if(this.museoMega[i].dev_label == "MEGA: 6-7-8"){
                  let options = JSON.parse(this.museoMega[i].options[0].dev_option_value);
                  this.dev_referenceD3 = this.museoMega[i].dev_reference;
                  this.capacidadT6 = options.cap1;
                  this.capacidadT7 = options.cap2;
                  this.capacidadT8 = options.cap3;
                  this.tipoCervezaT6 = options.beertype1;
                  this.tipoCervezaT7 = options.beertype2;
                  this.tipoCervezaT8 = options.beertype3;
                  this.temperaturaT6 = this.museoMega[i].lastreader.field6;
                  this.temperaturaT7 = this.museoMega[i].lastreader.field7;
                  this.temperaturaT8 = this.museoMega[i].lastreader.field8;
                  this.presionT6 = this.museoMega[i].lastreader.field3;
                  this.presionT7 = this.museoMega[i].lastreader.field4;
                  this.presionT8 = this.museoMega[i].lastreader.field5;
                  if(this.museoMega[i].lastreader.field2=="1"){
                    this.condicionT6Activo = true;
                  } else{ 
                    if(this.museoMega[i].lastreader.field2=="2"){
                      this.condicionT7Activo = true;
                    } else {
                      if(this.museoMega[i].lastreader.field2=="3"){
                        this.condicionT8Activo = true;
                      }
                    }
                  }
                  this.nvlT6 = this.museoMega[i].lastreader.field17;
                  if(this.nvlT6<0){
                    this.nvlT6 = 0;
                  }
                  this.nvlT7 = this.museoMega[i].lastreader.field18;
                  if(this.nvlT7<0){
                    this.nvlT7 = 0;
                  }
                  this.nvlT8 = this.museoMega[i].lastreader.field19;
                  if(this.nvlT8<0){
                    this.nvlT8 = 0;
                  }
                  this.nivelT6 = ((parseFloat(this.museoMega[i].lastreader.field17)*100) / parseInt(options.cap1));
                  this.nivelT7 = ((parseFloat(this.museoMega[i].lastreader.field18)*100) / parseInt(options.cap2));
                  this.nivelT8 = ((parseFloat(this.museoMega[i].lastreader.field19)*100) / parseInt(options.cap3));
                  if(mega678.tipoCerveza == 1){
                    this.consumoLitrosEstrella += mega678.consumoTotal;
                  }
                  if(mega678.tipoCerveza == 2){
                    this.consumoLitros1906 += mega678.consumoTotal;
                  }
                }
              }
              this.nivelT1 = this.asegurarValorNegativo(this.nivelT1);
              this.nivelT2 = this.asegurarValorNegativo(this.nivelT2);
              this.nivelT3 = this.asegurarValorNegativo(this.nivelT3);
              this.nivelT4 = this.asegurarValorNegativo(this.nivelT4);
              this.nivelT5 = this.asegurarValorNegativo(this.nivelT5);
              this.nivelT6 = this.asegurarValorNegativo(this.nivelT6);
              this.nivelT7 = this.asegurarValorNegativo(this.nivelT7);
              this.nivelT8 = this.asegurarValorNegativo(this.nivelT8);

              //Como máximo dos valores decimales
              this.consumoLitrosEstrella = parseFloat(this.consumoLitrosEstrella.toFixed(2));
              this.consumoLitros1906 = parseFloat(this.consumoLitros1906.toFixed(2));

              //const configurations: CircularFluidMeterConfig[] = [];

              const targetT1 = document.querySelector('#targetT1') as HTMLElement;
              const targetT2 = document.querySelector('#targetT2') as HTMLElement;
              const targetT3 = document.querySelector('#targetT3') as HTMLElement;
              const targetT4 = document.querySelector('#targetT4') as HTMLElement;
              const targetT5 = document.querySelector('#targetT5') as HTMLElement;
              const targetT6 = document.querySelector('#targetT6') as HTMLElement;
              const targetT7 = document.querySelector('#targetT7') as HTMLElement;
              const targetT8 = document.querySelector('#targetT8') as HTMLElement;

              if (targetT1 !== null) {
                let color = "black";
                let borderColor = "white";
                if(this.condicionT1Activo){
                  color = "#44dd2a";
                  borderColor = "#44dd2a";
                }
                this.FluidMeterT1 = new CircularFluidMeter(targetT1, {
                  initialProgress: 0,
                  borderWidth: 5,
                  maxProgress: 100,
                  backgroundColor: 'black',
                  borderColor: borderColor,
                  dropShadowColor: color,
                  bubbleColor: 'white',
                  fontFamily: 'Montserrat',
                  fontSize: 36,
                  progressFormatter: (value) => {
                    return `${value.toFixed(0)}%`;
                  },
                  fluidConfiguration: {
                    color: '#F28E1C',
                    horizontalSpeed: Speed.SLOW,
                    waveSpeed: Speed.SLOW
                  }
                });
                this.FluidMeterT1.progress = this.nivelT1
                this.fluidMeters.push(this.FluidMeterT1);
              }

              if (targetT2 !== null) {
                let color = "black";
                let borderColor = "white";
                if(this.condicionT2Activo){
                  color = "#44dd2a";
                  borderColor = "#44dd2a";
                }
                this.FluidMeterT2 = new CircularFluidMeter(targetT2, {
                  initialProgress: 0,
                  borderWidth: 5,
                  maxProgress: 100,
                  backgroundColor: 'black',
                  borderColor: borderColor,
                  dropShadowColor: color,
                  bubbleColor: 'white',
                  fontFamily: 'Montserrat',
                  fontSize: 36,
                  progressFormatter: (value) => {
                    return `${value.toFixed(0)}%`;
                  },
                  fluidConfiguration: {
                    color: '#F28E1C',
                    horizontalSpeed: Speed.SLOW,
                    waveSpeed: Speed.SLOW
                  }
                });
                this.FluidMeterT2.progress = this.nivelT2
                this.fluidMeters.push(this.FluidMeterT2);
              }

              if (targetT3 !== null) {
                let color = "black";
                let borderColor = "white";
                if(this.condicionT3Activo){
                  color = "#44dd2a";
                  borderColor = "#44dd2a";
                }
                this.FluidMeterT3 = new CircularFluidMeter(targetT3, {
                  initialProgress: 0,
                  borderWidth: 5,
                  maxProgress: 100,
                  backgroundColor: 'black',
                  borderColor: borderColor,
                  dropShadowColor: color,
                  bubbleColor: 'white',
                  fontFamily: 'Montserrat',
                  fontSize: 36,
                  progressFormatter: (value) => {
                    return `${value.toFixed(0)}%`;
                  },
                  fluidConfiguration: {
                    color: '#F28E1C',
                    horizontalSpeed: Speed.SLOW,
                    waveSpeed: Speed.SLOW
                  }
                });
                this.FluidMeterT3.progress = this.nivelT3
                this.fluidMeters.push(this.FluidMeterT3);
              }

              if (targetT4 !== null) {
                let color = "black";
                let borderColor = "white";
                if(this.condicionT4Activo){
                  color = "#44dd2a";
                  borderColor = "#44dd2a";
                }
                this.FluidMeterT4 = new CircularFluidMeter(targetT4, {
                  initialProgress: 0,
                  borderWidth: 5,
                  maxProgress: 100,
                  backgroundColor: 'black',
                  borderColor: borderColor,
                  dropShadowColor: color,
                  bubbleColor: 'white',
                  fontFamily: 'Montserrat',
                  fontSize: 36,
                  progressFormatter: (value) => {
                    return `${value.toFixed(0)}%`;
                  },
                  fluidConfiguration: {
                    color: '#F28E1C',
                    horizontalSpeed: Speed.SLOW,
                    waveSpeed: Speed.SLOW
                  }
                });
                this.FluidMeterT4.progress = this.nivelT4
                this.fluidMeters.push(this.FluidMeterT4);
              }

              if (targetT5 !== null) {
                let color = "black";
                let borderColor = "white";
                if(this.condicionT5Activo){
                  color = "#44dd2a";
                  borderColor = "#44dd2a";
                }
                this.FluidMeterT5 = new CircularFluidMeter(targetT5, {
                  initialProgress: 0,
                  borderWidth: 5,
                  maxProgress: 100,
                  backgroundColor: 'black',
                  borderColor: borderColor,
                  dropShadowColor: color,
                  bubbleColor: 'white',
                  fontFamily: 'Montserrat',
                  fontSize: 36,
                  progressFormatter: (value) => {
                    return `${value.toFixed(0)}%`;
                  },
                  fluidConfiguration: {
                    color: '#F28E1C',
                    horizontalSpeed: Speed.SLOW,
                    waveSpeed: Speed.SLOW
                  }
                });
                this.FluidMeterT5.progress = this.nivelT5
                this.fluidMeters.push(this.FluidMeterT5);
              }

              if (targetT6 !== null) {
                let color = "black";
                let borderColor = "white";
                if(this.condicionT6Activo){
                  color = "#44dd2a";
                  borderColor = "#44dd2a";
                }
                this.FluidMeterT6 = new CircularFluidMeter(targetT6, {
                  initialProgress: 0,
                  borderWidth: 5,
                  maxProgress: 100,
                  backgroundColor: 'black',
                  borderColor: borderColor,
                  dropShadowColor: color,
                  bubbleColor: 'white',
                  fontFamily: 'Montserrat',
                  fontSize: 36,
                  progressFormatter: (value) => {
                    return `${value.toFixed(0)}%`;
                  },
                  fluidConfiguration: {
                    color: '#F28E1C',                  
                    horizontalSpeed: Speed.SLOW,
                    waveSpeed: Speed.SLOW
                  }
                });
                this.FluidMeterT6.progress = this.nivelT6
                this.fluidMeters.push(this.FluidMeterT6);
              }

              if (targetT7 !== null) {
                let color = "black";
                let borderColor = "white";
                if(this.condicionT7Activo){
                  color = "#44dd2a";
                  borderColor = "#44dd2a";
                }
                this.FluidMeterT7 = new CircularFluidMeter(targetT7, {
                  initialProgress: 0,
                  borderWidth: 5,
                  maxProgress: 100,
                  backgroundColor: 'black',
                  borderColor: borderColor,
                  dropShadowColor: color,
                  bubbleColor: 'white',
                  fontFamily: 'Montserrat',
                  fontSize: 36,
                  progressFormatter: (value) => {
                    return `${value.toFixed(0)}%`;
                  },
                  fluidConfiguration: {
                    color: '#F28E1C',                  
                    horizontalSpeed: Speed.SLOW,
                    waveSpeed: Speed.SLOW
                  }
                });
                this.FluidMeterT7.progress = this.nivelT7
                this.fluidMeters.push(this.FluidMeterT7);
              }

              if (targetT8 !== null) {
                let color = "black";
                let borderColor = "white";
                if(this.condicionT8Activo){
                  color = "#44dd2a";
                  borderColor = "#44dd2a";
                }
                this.FluidMeterT8 = new CircularFluidMeter(targetT8, {
                  initialProgress: 0,
                  borderWidth: 5,
                  maxProgress: 100,
                  backgroundColor: 'black',
                  borderColor: borderColor,
                  dropShadowColor: color,
                  bubbleColor: 'white',
                  fontFamily: 'Montserrat',
                  fontSize: 36,
                  progressFormatter: (value) => {
                    return `${value.toFixed(0)}%`;
                  },
                  fluidConfiguration: {
                    color: '#F28E1C',                  
                    horizontalSpeed: Speed.SLOW,
                    waveSpeed: Speed.SLOW
                  }
                });
                this.FluidMeterT8.progress = this.nivelT8
                this.fluidMeters.push(this.FluidMeterT8);
              }
            }
          });
        }
      });
    } else {
      this.mostrar = false;
    }
    this.intervalId = setInterval(() => {
      this.time = new Date();
    }, 1000);
    this.intervalId = setInterval(() => {
      this.historicosRaw = [];
      this.consumoLitrosEstrellaCopia = 0;
      this.consumoLitros1906Copia = 0
      this.calcularDatosMega();
    }, 10000);
  }

  soloDosDecimalesConComa(numero: number){
    if(Number.isNaN(numero)){
      return 0
    } else {
      return numero.toLocaleString(this.userData.region, { maximumFractionDigits: 2 });
    }
  }

  soloDosDecimalesConString(cadena: string){
    let numero;
    numero = parseFloat(cadena);
    if(Number.isNaN(numero)){
      return 0
    } else {
      return numero.toLocaleString(this.userData.region, { maximumFractionDigits: 2 });
    }
  }

  calcularDatosMega(){
    this.establishmentSubscription = this.deviceService.getDevicesDataNew().subscribe({
      next:resp =>{
        this.museoMega = [];
        this.establishmentData = resp;
        for(let i=0; i<this.establishmentData.length; i++){
          if (this.establishmentData[i].dev_est_id == 12){
            this.museoMega.push(this.establishmentData[i]);
          }
        }
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han recibido demasiadas peticiones, espere un minuto por favor, y la página se recargará automáticamente.";
          const storedTimestamp = localStorage.getItem('firstErrorTimestamp');
          if(storedTimestamp == null){
            this.firstErrorTimestamp = new Date().getTime(); // Guardar el timestamp del primer error
            localStorage.setItem('firstErrorTimestamp', this.firstErrorTimestamp.toString());
          } else {
            this.firstErrorTimestamp = storedTimestamp !== null ? parseInt(storedTimestamp, 10) : null;
          }
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete:() =>{
        const referenciasConGuiones = this.museoMega.map((elemento: any) => `-${elemento.dev_reference}-`);
        this.historicoDiaSubscription1 = this.deviceService.getMultiHistoricRaw(referenciasConGuiones,this.fechaFormateada, this.obtenerDiaSiguiente(this.fechaFormateada),"0").subscribe({
          next: resp => {
            for(let i=0; i<resp.length; i++){
              let consumo = 0;
              for (let j = 0; j < resp[i].readers_raw.length; j++) {
                consumo +=
                  (resp[i].readers_raw[j].field11 ?? 0) +
                  (resp[i].readers_raw[j].field12 ?? 0) +
                  (resp[i].readers_raw[j].field13 ?? 0) +
                  (resp[i].readers_raw[j].field14 ?? 0) +
                  (resp[i].readers_raw[j].field15 ?? 0) +
                  (resp[i].readers_raw[j].field16 ?? 0) +
                  (resp[i].readers_raw[j].field20 ?? 0) +
                  (resp[i].readers_raw[j].field21 ?? 0) +
                  (resp[i].readers_raw[j].field22 ?? 0);
              }
              this.historicosRaw.push({
                nombre: resp[i].dev_label,
                tipoCerveza: resp[i].readers_raw[0].beer_type_id_1,
                consumoTotal: parseFloat(consumo.toFixed(2)),
              });
            }
          }, error: err => {
            if (err.status == 429) {
              this.errorMessage = "Se han recibido demasiadas peticiones, espere un minuto por favor, y la página se recargará automáticamente.";
              const storedTimestamp = localStorage.getItem('firstErrorTimestamp');
              if(storedTimestamp == null){
                this.firstErrorTimestamp = new Date().getTime(); // Guardar el timestamp del primer error
                localStorage.setItem('firstErrorTimestamp', this.firstErrorTimestamp.toString());
              } else {
                this.firstErrorTimestamp = storedTimestamp !== null ? parseInt(storedTimestamp, 10) : null;
              }
              this.recargarPaginaDespuesDeTiempo();
            } else {
              this.errorMessage = err.error.message;
            }
          }, complete: () => {
            const mega123 = this.historicosRaw.find((historico:any) => historico.nombre == "MEGA: 1-2-3");
            const mega45 = this.historicosRaw.find((historico:any) => historico.nombre == "MEGA: 4-5");
            const mega678 = this.historicosRaw.find((historico:any) => historico.nombre == "MEGA: 6-7-8");
            console.log(mega123);
            console.log(mega45);
            console.log(mega678);

            //Guardamos los datos de los dispositivos de museo mega
            for(let i=0; i<this.museoMega.length; i++){
              if(this.museoMega[i].dev_label == "MEGA: 1-2-3"){
                let options = JSON.parse(this.museoMega[i].options[0].dev_option_value);
                this.dev_referenceD1 = this.museoMega[i].dev_reference;
                this.capacidadT1 = options.cap1;
                this.capacidadT2 = options.cap2;
                this.capacidadT3 = options.cap3;
                this.tipoCervezaT1 = options.beertype1;
                this.tipoCervezaT2 = options.beertype2;
                this.tipoCervezaT3 = options.beertype3;
                this.temperaturaT1 = this.museoMega[i].lastreader.field6;
                this.temperaturaT2 = this.museoMega[i].lastreader.field7;
                this.temperaturaT3 = this.museoMega[i].lastreader.field8;
                this.presionT1 = this.museoMega[i].lastreader.field3;
                this.presionT2 = this.museoMega[i].lastreader.field4;
                this.presionT3 = this.museoMega[i].lastreader.field5;
                this.nvlT1 = this.museoMega[i].lastreader.field17;
                if(this.nvlT1<0){
                  this.nvlT1 = 0;
                }
                this.nvlT2 = this.museoMega[i].lastreader.field18;
                if(this.nvlT2<0){
                  this.nvlT2 = 0;
                }
                this.nvlT3 = this.museoMega[i].lastreader.field19;
                if(this.nvlT3<0){
                  this.nvlT3 = 0;
                }
                this.nivelT1 = ((parseFloat(this.museoMega[i].lastreader.field17)*100) / parseInt(options.cap1));
                this.nivelT2 = ((parseFloat(this.museoMega[i].lastreader.field18)*100) / parseInt(options.cap2));
                this.nivelT3 = ((parseFloat(this.museoMega[i].lastreader.field19)*100) / parseInt(options.cap3));
                if(mega123.tipoCerveza == 1){
                  this.consumoLitrosEstrellaCopia += mega123.consumoTotal;
                }
                if(mega123.tipoCerveza == 2){
                  this.consumoLitros1906Copia += mega123.consumoTotal;
                }
              }
              if(this.museoMega[i].dev_label == "MEGA: 4-5"){
                let options = JSON.parse(this.museoMega[i].options[0].dev_option_value);
                this.dev_referenceD2 = this.museoMega[i].dev_reference;
                this.capacidadT4 = options.cap1;
                this.capacidadT5 = options.cap2;
                this.tipoCervezaT4 = options.beertype1;
                this.tipoCervezaT5 = options.beertype2;
                this.temperaturaT4 = this.museoMega[i].lastreader.field6;
                this.temperaturaT5 = this.museoMega[i].lastreader.field7;
                this.presionT4 = this.museoMega[i].lastreader.field3;
                this.presionT5 = this.museoMega[i].lastreader.field4;
                this.nvlT4 = this.museoMega[i].lastreader.field17;
                if(this.nvlT4<0){
                  this.nvlT4 = 0;
                }
                this.nvlT5 = this.museoMega[i].lastreader.field18;
                if(this.nvlT5<0){
                  this.nvlT5 = 0;
                }
                this.nivelT4 = ((parseFloat(this.museoMega[i].lastreader.field17)*100) / parseInt(options.cap1));
                this.nivelT5 = ((parseFloat(this.museoMega[i].lastreader.field18)*100) / parseInt(options.cap2));
                if(mega45.tipoCerveza == 1){
                  this.consumoLitrosEstrellaCopia += mega45.consumoTotal;
                }
                if(mega45.tipoCerveza == 2){
                  this.consumoLitros1906Copia += mega45.consumoTotal;
                }
              }
              if(this.museoMega[i].dev_label == "MEGA: 6-7-8"){
                let options = JSON.parse(this.museoMega[i].options[0].dev_option_value);
                this.dev_referenceD3 = this.museoMega[i].dev_reference;
                this.capacidadT6 = options.cap1;
                this.capacidadT7 = options.cap2;
                this.capacidadT8 = options.cap3;
                this.tipoCervezaT6 = options.beertype1;
                this.tipoCervezaT7 = options.beertype2;
                this.tipoCervezaT8 = options.beertype3;
                this.temperaturaT6 = this.museoMega[i].lastreader.field6;
                this.temperaturaT7 = this.museoMega[i].lastreader.field7;
                this.temperaturaT8 = this.museoMega[i].lastreader.field8;
                this.presionT6 = this.museoMega[i].lastreader.field3;
                this.presionT7 = this.museoMega[i].lastreader.field4;
                this.presionT8 = this.museoMega[i].lastreader.field5;
                this.nvlT6 = this.museoMega[i].lastreader.field17;
                if(this.nvlT6<0){
                  this.nvlT6 = 0;
                }
                this.nvlT7 = this.museoMega[i].lastreader.field18;
                if(this.nvlT7<0){
                  this.nvlT7 = 0;
                }
                this.nvlT8 = this.museoMega[i].lastreader.field19;
                if(this.nvlT8<0){
                  this.nvlT8 = 0;
                }
                this.nivelT6 = ((parseFloat(this.museoMega[i].lastreader.field17)*100) / parseInt(options.cap1));
                this.nivelT7 = ((parseFloat(this.museoMega[i].lastreader.field18)*100) / parseInt(options.cap2));
                this.nivelT8 = ((parseFloat(this.museoMega[i].lastreader.field19)*100) / parseInt(options.cap3));
                if(mega678.tipoCerveza == 1){
                  this.consumoLitrosEstrellaCopia += mega678.consumoTotal;
                }
                if(mega678.tipoCerveza == 2){
                  this.consumoLitros1906Copia += mega678.consumoTotal;
                }
              }
            }
            this.nivelT1 = this.asegurarValorNegativo(this.nivelT1);
            this.nivelT2 = this.asegurarValorNegativo(this.nivelT2);
            this.nivelT3 = this.asegurarValorNegativo(this.nivelT3);
            this.nivelT4 = this.asegurarValorNegativo(this.nivelT4);
            this.nivelT5 = this.asegurarValorNegativo(this.nivelT5);
            this.nivelT6 = this.asegurarValorNegativo(this.nivelT6);
            this.nivelT7 = this.asegurarValorNegativo(this.nivelT7);
            this.nivelT8 = this.asegurarValorNegativo(this.nivelT8);

            //Como máximo dos valores decimales
            this.consumoLitrosEstrellaCopia = parseFloat(this.consumoLitrosEstrellaCopia.toFixed(2));
            this.consumoLitros1906Copia = parseFloat(this.consumoLitros1906Copia.toFixed(2));

            this.FluidMeterT1!.progress = this.nivelT1;
            this.FluidMeterT2!.progress = this.nivelT2;
            this.FluidMeterT3!.progress = this.nivelT3;
            this.FluidMeterT4!.progress = this.nivelT4;
            this.FluidMeterT5!.progress = this.nivelT5;
            this.FluidMeterT6!.progress = this.nivelT6;
            this.FluidMeterT7!.progress = this.nivelT7;
            this.FluidMeterT8!.progress = this.nivelT8;

            this.consumoLitrosEstrella = this.consumoLitrosEstrellaCopia;
            this.consumoLitros1906 = this.consumoLitros1906Copia;
          }
        });
      }
    });
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
    clearInterval(this.intervaCalcularDatosMega);
    if (this.establishmentSubscription) {
      this.establishmentSubscription.unsubscribe();
    } 
    if (this.historicoDiaSubscription) {
      this.historicoDiaSubscription.unsubscribe();
    }
  }

  recargarPaginaDespuesDeTiempo() {
    if (this.firstErrorTimestamp !== null) {
      const currentTime = new Date().getTime();
      const elapsedTime = currentTime - this.firstErrorTimestamp;
      const remainingTime = Math.max(this.tiempoEsperaRecarga - elapsedTime, 0);
      console.log(remainingTime);
      setTimeout(() => {
        this.reloadCurrentRoute();
      }, remainingTime);
    } else {
      setTimeout(() => {
        this.reloadCurrentRoute();
      }, this.tiempoEsperaRecarga);
    }
  }

  reloadCurrentRoute() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
      this.error429.setError(false);
    });
    localStorage.removeItem('firstErrorTimestamp');
  }

  /*recargarPaginaDespuesDeTiempo() {
    setTimeout(() => {
      this.reloadCurrentRoute();
    }, this.tiempoEsperaRecarga);
  }

  reloadCurrentRoute() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }*/

  asegurarValorNegativo(variable:number){
    if(variable < 0){
      return 0;
    }
    return variable;
  }

  obtenerDiaSiguiente(fechaStr: string): string {
    const fecha = parse(fechaStr, 'yyyy-MM-dd', new Date());
    const diaSiguiente = addDays(fecha, 1);
    const diaSiguienteStr = format(diaSiguiente, 'yyyy-MM-dd');
    return diaSiguienteStr;
  }

  sonFechasIguales(fecha1: Date, fecha2: Date) {
    //console.log(fecha1);
    //console.log(fecha2);
    return (
      fecha1.getFullYear() === fecha2.getFullYear() &&
      fecha1.getMonth() === fecha2.getMonth() &&
      fecha1.getDate() === fecha2.getDate()
    );
  }

}
